import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1e8eebc"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CsrdIntro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/csrd/Intro.vue').default,IxBtnAddValueChain: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddValueChain.vue').default,IxPageLoading: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/PageLoading.vue').default,IxDialogDelValueChain: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/DelValueChain.vue').default,IxBtnAddActivity: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddActivity.vue').default,IxCardActivity: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/Activity.vue').default,IxCardIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/Iro.vue').default,IxBtnAddIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddIro.vue').default,IxDialogDelStakeholder: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/DelStakeholder.vue').default,IxBtnAddStakeholder: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddStakeholder.vue').default})
